import React, { Suspense, memo } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

// 通用加载组件
const LoadingFallback = memo(({ message = "加载中..." }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
      gap: 2,
    }}
  >
    <CircularProgress size={40} />
    <Typography variant="body2" color="text.secondary">
      {message}
    </Typography>
  </Box>
));

LoadingFallback.displayName = "LoadingFallback";

// 懒加载路由包装器
const LazyRoute = ({
  component: Component,
  fallback,
  loadingMessage,
  ...props
}) => {
  const FallbackComponent =
    fallback || (() => <LoadingFallback message={loadingMessage} />);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Suspense fallback={<FallbackComponent />}>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            width: "100%",
          }}
        >
          <Component {...props} />
        </Box>
      </Suspense>
    </Box>
  );
};

export default memo(LazyRoute);